var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSaved(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.7682 21.1532C2.00843 21.2557 2.26746 21.3068 2.52864 21.3032C2.94958 21.2992 3.35481 21.1429 3.6693 20.8632L8.31199 16.7633C8.54279 16.5641 8.83755 16.4545 9.14247 16.4545C9.4474 16.4545 9.74216 16.5641 9.97295 16.7633L14.6156 20.8632C14.8681 21.0866 15.1798 21.2324 15.5132 21.2831C15.8466 21.3337 16.1876 21.287 16.4951 21.1487C16.8026 21.0103 17.0636 20.7862 17.2467 20.5031C17.4298 20.2201 17.5273 19.8903 17.5273 19.5532V3.23338C17.5273 2.50404 17.2374 1.80457 16.7214 1.28885C16.2054 0.773127 15.5055 0.483398 14.7757 0.483398H3.51921C2.78945 0.483398 2.08957 0.773127 1.57354 1.28885C1.05752 1.80457 0.76762 2.50404 0.76762 3.23338V19.5532C0.761532 19.8881 0.852836 20.2175 1.03045 20.5016C1.20806 20.7856 1.46435 21.012 1.7682 21.1532Z",
    fill: "#E81A3F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaved);
export default __webpack_public_path__ + "static/media/saved.49b52760.svg";
export { ForwardRef as ReactComponent };